






































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { LOCALE_CODE_DA, LOCALE_CODE_EN } from '@/i18n';

@Component
export default class SideNav extends Vue {
  expanded = true;

  @Getter('setSignupData') setSignupData: any;

  DA_CODE = LOCALE_CODE_DA;

  EN_CODE = LOCALE_CODE_EN;

  get locale(): string {
    return this.$i18n.locale;
  }

  setLocale(locale: string) {
    this.$i18n.locale = locale;

    // Store selected locale in signupdata for future use
    this.setSignupData({
      locale,
    });
  }
}
